import {IContextMenuActions, IContextMenuActionsPointer} from "/@back@/commons/actionables.js";
import {BarActions} from "/@back@/commons/widgets/bars.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {AgEltBoxSelection, AgWedletBoxSelectionSingleElt, IEltBoxSelection} from "/@back@/edit/wed/features/boxSel.js";
import {IWedFocusBarPointer} from "/@back@/edit/wed/features/commonBar.js";
import {IWedEditorTxtSel, TxtSelMgr, TxtSelMgrFrozen} from "/@back@/edit/wed/features/txtSel.js";
import {isWedChildrenElt, IWedChildrenElt, IWedDisplayElt, IWedletModel, IWedSelector, NoneModel, WED, WedModel} from "/@back@/edit/wed/wedCore.js";
import {WedMgr} from "/@back@/edit/wed/wedEditor.js";
import {AgEltBoxInputAnnotable, IBoxElement, IBoxInputDiffMaker, removeAnnots} from "/@back@/edit/wed/wedlets/box/boxTags.js";
import {copyAsXml, copyDefault, copyPasteMenus, createTxtAction, cutDefault, hintsMenu, ITxtAction, pasteAsString, pasteAsText, pasteDefault, spellcheckMenu} from "/@back@/edit/wed/wedlets/txt/txtActions.js";
//Actions des tables.
import {TXTTABLE} from "/@back@/edit/wed/wedlets/txt/txtTable.js";
import {
	InlEmpty,
	InlImg,
	InlLeaf,
	InlLink,
	InlNote,
	InlObject,
	InlPhrase,
	InlStyle,
	TxtCaption,
	TxtCell,
	TxtCol,
	TxtDiv,
	TxtElement,
	TxtEmpty,
	TxtLI,
	TxtMember,
	TxtObject,
	TxtOL,
	TxtPara,
	TxtParaLike,
	TxtRow,
	TxtSL,
	TxtStr,
	TxtTable,
	TxtTitle,
	TxtUL
} from "/@back@/edit/wed/wedlets/txt/txtTags.js";
import {
	adjustVirtualsPara,
	adjustVirtualsStr,
	beforeInputHandler,
	deleteFromSel,
	doInput,
	findTxtEltFirstChild,
	findTxtEltOrRootParent,
	findTxtParaLikeFrom,
	findTxtStrFirstChild,
	findTxtStrLastChild,
	findTxtStrNext,
	findTxtStrParent,
	findTxtStrPrevious,
	IFixCaret,
	IFixSelection,
	IS_TxtElement,
	IS_TxtStr,
	ITxtColWidthMgr,
	keyDownHandler,
	keyPressHandler
} from "/@back@/edit/wed/wedlets/txt/txtUtils.js";
import {
	EWedletEditMode,
	EWedletEditModeLabel,
	ICustomClipboard,
	IEditableWedlet,
	IElementWedlet,
	IParentWedlet,
	IRootWedlet,
	IWedAnnotPointer,
	IWedlet,
	IWedletActionCtx,
	WEDLET,
	WedletActionCtxBase
} from "/@back@/edit/wed/wedlets/wedlet.js";
import {isWedletSingleElt, IWedletSingleElt} from "/@back@/edit/wed/wedlets/wedletSingleElt.js";
import {AccelKeyMgr, ACTION, Action, ActionSeparator, IAccelKeyMgrPointer, IAction, ISpellcheckContextPointer} from "/@lib@/commons/actions.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {IRefreshHook} from "/@lib@/commons/utils/signboard.js";
import {DOM, ENodeType, INodeFilter} from "/@lib@/commons/xml/dom.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {IJmlNode, IJmlObj, IJmlSet, IJmlSubSet, JML} from "/@lib@/commons/xml/jml.js";
import {IXAddr, XA} from "/@lib@/commons/xml/xAddr.js";
import {ISkImporter, OSkPasteContext} from "/@lib@/edit/schema/schemaMeta.js";
// Force la déclaration des SkMeta de texte riche.
import "/@lib@/edit/schema/schemaMetaTxt.js";
import {AgEltBoxInsertDrawerTxt} from "/@back@/edit/wed/features/insMgrTxt.js";
import {IDiffAnnotValue, ISkDiffAnnot} from "/@lib@/edit/schema/diff.js";
import {ISkAnnot} from "/@lib@/edit/schema/schemaAnnots.js";
import {WedDiffMark, WedDiffValue} from "/@back@/edit/wed/wedlets/diff/diffTags.js";
import {BoxModel} from "/@back@/edit/wed/wedlets/box/box.js";
import {ITxtStrTextNode} from "/@back@/edit/wed/wedlets/txt/txtStr.js";
import {LANG} from "/@lib@/commons/lang.js";
import {Desk} from "/@lib@/commons/desk.js";
import {CLIPBOARD} from "/@lib@/commons/clipboard.js";

export const TXT_NS = "scenari.eu:wed:txt";

/**
 * Modèle pour les balises block et inline du texte.
 * <txt-root>
 *   <wed:children defaultDisplay="sc:para">
 *     <wed:bind eltName="sc:para" label="Paragraphe" wedlet="TxtPara" txt:style="display:block;"/>
 *   </wed:children>
 *   <txt:descendants>
 *   </txt:descendants>
 *   <txt:uiconfig>
 *   </txt:uiconfig>
 * </txt-root>
 */
export abstract class TxtModel implements IWedletModel {

	/** Nom de l'attribut 'role' dans les flux xml. TODO à configurer dans le TxtModel. */
	static ATTNAME_role = 'role';

	/**
	 *
	 */
	static wedSelector: IWedSelector = function (wedModel: IWedletModel, node: IJmlNode | string, ctx: WedMgr | IWedlet): number {
		if (wedModel instanceof TxtModel) {
			//score en fonction du matching du role.
			if (wedModel.nodeType === ENodeType.element && (node == null || JML.jmlNode2nodeType(node) === ENodeType.element)) {
				if (wedModel.role === null) {
					//role non spécifié dans le modèle, config par défaut.
					return 10;
				} else if (wedModel.role === ((node && (node as IJmlObj)[TxtModel.ATTNAME_role]) || "")) {
					return WedModel.SELECTOR_PERFECT_MATCH;
				}
				return WedModel.SELECTOR_REJECT;
			}
			//match text, comment
			return WedModel.SELECTOR_PERFECT_MATCH;
		} else if (wedModel instanceof NoneModel) {
			return 1;
		}
		return WedModel.SELECTOR_REJECT;
	};

	nodeType: ENodeType;
	nodeName: string;

	//Notion de modes pas utilisés dans Txt. à voir, exigerait une balise dans la
	// config en plus de la notion d'exclude  : <include eltName="" callModes=""/> ?
	get modes(): string[] {return WED.DEFAULT_MODES};

	set modes(val: string[]) {}//setter obligatoire pour les modèles fils directs de txt-root (initialisés via les mécanismes génériques).
	//callModes: string[];

	nodeLabel?: string;

	config: Element;

	get isInline() {return false}

	/**
	 * Role de la balise Txt valide pour ce wedlet.
	 * Si null, configuration par défaut pour les roles non déclarés explicitement dans le modèle
	 * (ne signifie pas nécessairement inconnu du point de vue du schéma).
	 *
	 */
	role: string;

	/**
	 * Pour les TxtModel qui définissent un schéma connu et déclarés dans la descendance d'un <txt-root/> définit dans le fichier WED.
	 * null si ce model est spécifié dans le registre central des WED pour constituer les implémentations par défaut
	 * des structures inconnues.
	 */
	txtRootModel: ITxtRootModel;

	/** WedletModel pour l'affichage du panel d'édition de ce tag (wedlet Box bindé sur le tag incluant attributs, metas, contenu). */
	panelModel: IWedletModel;

	/** WedletModel pour l'affichage de la preview de ce tag (wedlet Box bindé sur le tag incluant attributs, metas, contenu). */
	renderingModel: IWedletModel;

	/** Nom de l'attr role. */
	get roleAttName(): string {return TxtModel.ATTNAME_role}

	/** Nom de la balise metas. */
	metasName: string;

	/** Fonction de redessinement du wedlet suite à création/modification/suppression des metas. */
	refreshLib: string;
	refreshMeth: string;
	refreshSvc: string;

	get hasRefresh(): boolean {return this.refreshSvc != null || this.refreshLib != null}

	callRefresh(elt: TxtElement) {
		let refresh: ITxtRefresh;
		if (this.refreshSvc) refresh = REG.findReg(elt).getSvc(this.refreshSvc) as ITxtRefresh;
		if (!refresh) {
			const lib = elt.wedMgr.wedModel.jsLibs[this.refreshLib];
			if (lib) refresh = lib[this.refreshMeth];
		}
		if (refresh) refresh.call(elt);
		else console.log("ITxtRefresh function not found. svc=" + this.refreshSvc + " lib=" + this.refreshLib + "." + this.refreshMeth);
	}

	protected onCreateLib: string;
	protected onCreateMeth: string;
	protected onCreateSvc: string;

	get hasOnCreateHook(): boolean {return this.onCreateSvc != null || this.onCreateLib != null}

	callOnCreateHook(parent: ITxtElement): Promise<IJmlSet> {
		let hook: ITxtOnCreateHook;
		if (this.onCreateSvc) hook = REG.findReg(parent).getSvc(this.onCreateSvc) as ITxtOnCreateHook;
		if (!hook) {
			const lib = (parent instanceof TxtElement ? parent : parent.wedlet).wedMgr.wedModel.jsLibs[this.onCreateLib];
			if (lib) {
				hook = lib[this.onCreateMeth];
			}
		}
		if (hook) return hook.call(this, parent);
		console.log("ITxtOnCreateHook function not found. svc=" + this.onCreateSvc + " lib=" + this.onCreateLib + "." + this.onCreateMeth);
		return Promise.resolve(null);
	}

	/**
	 * Modèles fils connus du schéma.
	 */
	get txtWedModels(): TxtModel[] {return null}

	getTxtWedModel(tagName: string, role?: string): TxtModel {
		if (this.txtWedModels) for (const txtModel of this.txtWedModels) if (txtModel.nodeName === tagName && (role == null || txtModel.role === role)) return txtModel;
		return null;
	}

	/** Model de paragraphe déclaré dans le schéma.*/
	get paraModel(): TxtParaModel {return this.txtRootModel ? this.txtRootModel.paraModel : null}

	/** Model de noeud texte déclaré dans le schéma. */
	get strModel(): TxtStrModel {return this.txtRootModel ? this.txtRootModel.strModel : null}

	initModel(cnf: Element) {
		this.config = cnf;
		this.role = cnf.getAttributeNS(TXT_NS, 'role');// || "" NON sinon bloque les TxtModel génériques (non reconnus).
		//this.callModes = WED.parseModes(cnf.getAttributeNS(TXT_NS, "callModes") || cnf.getAttributeNS(TXT_NS, "modes"));
		this.nodeLabel = cnf.getAttribute('label');
		this.txtRootModel = cnf.closest('txt-root,txt-root-inline') as any as ITxtRootModel;
		for (let tag = cnf.firstElementChild; tag; tag = tag.nextElementSibling) {
			if (tag.namespaceURI === TXT_NS) {
				const nm = tag.localName;
				if (nm === 'metas') {
					this.metasName = tag.getAttribute('eltName');
				} else if (nm === 'refresh') {
					this.refreshSvc = tag.getAttribute('svc');
					const lib = tag.getAttribute('lib');
					if (lib) {
						this.refreshLib = lib;
						this.refreshMeth = tag.getAttribute('method');
					}
				} else if (nm === 'onCreate') {
					this.onCreateSvc = tag.getAttribute('svc');
					const lib = tag.getAttribute('lib');
					if (lib) {
						this.onCreateLib = lib;
						this.onCreateMeth = tag.getAttribute('method');
					}
				} else if (nm === 'panel') {
					this.panelModel = WED.newWedletModel(tag.getAttribute('wedlet') || 'Box');
					this.panelModel.nodeType = this.nodeType;
					this.panelModel.nodeName = this.nodeName;
					this.panelModel.perms = WED.parsePerms(tag);
					this.panelModel.initModel(tag);
				} else if (nm === 'rendering') {
					this.renderingModel = WED.newWedletModel(tag.getAttribute('wedlet') || 'Box');
					this.renderingModel.nodeType = this.nodeType;
					this.renderingModel.nodeName = this.nodeName;
					this.renderingModel.perms = WED.parsePerms(tag);
					this.renderingModel.initModel(tag);
				} else if (nm === 'diff') {
					this.initDiff(tag);
				}
			}
		}
	}

	/** tag = {scenari.eu:wed:txt}:diff */
	protected initDiff(tag: Element) {}

	createWedlet(parent: IParentWedlet, displayContext?: IWedDisplayElt): TxtElement {
		return this.newWedlet().initWedlet(this, parent, displayContext);
	}

	protected abstract newWedlet(): TxtElement;

	createRootWedlet(wContainer: Element, insertBefore: Node, wedMgr: WedMgr): IRootWedlet {
		throw Error("Txt wedlets not allowed as root wedlet.");
	}

	newJml(): IJmlNode {
		const jml = {'': this.nodeName} as IJmlObj;
		if (this.role) jml[TxtModel.ATTNAME_role] = this.role;
		return jml;
	}

	buildModelForFragment(insertCtx: IWedlet & ITxtElement): IWedletModel {
		return insertCtx.txtRoot.wedlet.model;
	}
}

/** Api free pour customiser la rendition d'un TxtElement. */
export type ITxtRefresh = (this: TxtElement) => void;

/** Api free pour customiser la création d'un TxtElement. */
export type ITxtOnCreateHook = (this: TxtModel, parent: ITxtElement) => Promise<IJmlSet>;

/** Api free pour customiser l'affichage d'une diff. Utilisable uniquement sur TxtObjectModel et TxtEmptyModel */
export interface ITxtAnnotDiff {

	/**
	 * Ajoute une diff. TxtElement.wedAnnotDiff devrait être renseigné à l'ajout de la 1ère annotation.
	 * @return true si la gestion de cette annot a été prise en charge
	 */
	addDiff(elt: TxtObject, annot: ISkDiffAnnot): boolean

	/** Supprime une diff. TxtElement.wedAnnotDiff devrait être nullifié à la suppression de la dernière annotation. */
	removeDiff(elt: TxtObject, annot: ISkDiffAnnot): void
}


export interface IInlWrapModel extends TxtModel {
	splitPriority: number;
}

export abstract class TxtContainerModel extends TxtModel {

	initModel(cnf: Element) {
		super.initModel(cnf);
	}

	//TODO mécanismes d'excludes des balises filles.
	get txtWedModels(): TxtModel[] {return this.txtRootModel ? this.txtRootModel.preferedBlockTxtModels : null}
}

export abstract class InlineContentModel extends TxtModel {

	//TODO mécanismes d'excludes des balises filles.
	get txtWedModels(): TxtModel[] {return this.txtRootModel ? this.txtRootModel.preferedInlineTxtModels : null}
}

// ***** blocks *****

export class TxtParaModel extends InlineContentModel {
	protected newWedlet(): TxtElement {return new TxtPara()}

	newJml(): IJmlObj {
		const jml = {'': this.nodeName, 'xml:space': 'preserve'} as IJmlObj;
		if (this.role) jml[TxtModel.ATTNAME_role] = this.role;
		return jml;
	}
}

WED.registerWedletModel("TxtPara", TxtParaModel);

/** sc:itemizedList */
export class TxtULModel extends TxtModel {
	itemModel: TxtLIModel;
	titleModel: TxtCaptionModel;
	childrenModels: TxtModel[];

	initModel(cnf: Element) {
		super.initModel(cnf);
		for (let ch = cnf.firstElementChild; ch; ch = ch.nextElementSibling) {
			if (ch.localName === 'item' && ch.namespaceURI === TXT_NS) {
				this.itemModel = WED.buildBind(ch, 'TxtLI') as TxtLIModel;
			} else if (ch.localName === 'title' && ch.namespaceURI === TXT_NS) {
				this.titleModel = WED.buildBind(ch, 'TxtTitle') as TxtCaptionModel;
			}
		}
		if (!this.itemModel) throw Error("No txt:item tag declared in wed: " + DOM.debug(cnf));
		this.childrenModels = this.titleModel ? [this.titleModel, this.itemModel] : [this.itemModel];
	}

	get txtWedModels(): TxtModel[] {return this.childrenModels}

	protected newWedlet(): TxtElement {return new TxtUL()}
}

WED.registerWedletModel("TxtUL", TxtULModel);

/** sc:orderedList */
export class TxtOLModel extends TxtULModel {
	protected newWedlet(): TxtElement {return new TxtOL()}
}

WED.registerWedletModel("TxtOL", TxtOLModel);

/** sc:simpleList */
export class TxtSLModel extends TxtModel {
	memberModel: TxtMemberModel;
	titleModel: TxtCaptionModel;
	childrenModels: TxtModel[];

	initModel(cnf: Element) {
		super.initModel(cnf);
		for (let ch = cnf.firstElementChild; ch; ch = ch.nextElementSibling) {
			if (ch.localName === 'member' && ch.namespaceURI === TXT_NS) {
				this.memberModel = WED.buildBind(ch, 'TxtMember') as TxtMemberModel;
			} else if (ch.localName === 'title' && ch.namespaceURI === TXT_NS) {
				this.titleModel = WED.buildBind(ch, 'TxtTitle') as TxtCaptionModel;
			}
		}
		if (!this.memberModel) throw Error("No txt:member tag declared in wed: " + DOM.debug(cnf));
		this.childrenModels = this.titleModel ? [this.titleModel, this.memberModel] : [this.memberModel];
	}

	get paraModel(): TxtMemberModel {return this.memberModel}

	get txtWedModels(): TxtModel[] {return this.childrenModels}

	protected newWedlet(): TxtElement {return new TxtSL()}
}

WED.registerWedletModel("TxtSL", TxtSLModel);


/** sc:div */
export class TxtDivModel extends TxtContainerModel {
	protected newWedlet(): TxtDiv {return new TxtDiv()}
}

WED.registerWedletModel("TxtDiv", TxtDivModel);

/** sc:table */
export class TxtTableModel extends TxtModel {
	captionModel: TxtCaptionModel;
	colModels: TxtColModel[] = [];
	rowModels: TxtRowModel[] = [];
	childrenModels: TxtModel[] = [];

	initModel(cnf: Element) {
		super.initModel(cnf);
		for (let ch = cnf.firstElementChild; ch; ch = ch.nextElementSibling) {
			if (ch.namespaceURI === TXT_NS) {
				let model: any;
				if (ch.localName === 'column') {
					model = WED.buildBind(ch, 'TxtCol') as TxtColModel;
					if (model) this.colModels.push(model);
				} else if (ch.localName === 'row') {
					model = WED.buildBind(ch, 'TxtRow') as TxtRowModel;
					if (model) this.rowModels.push(model);
				} else if (ch.localName === 'caption') {
					model = this.captionModel = WED.buildBind(ch, 'TxtTitle') as TxtCaptionModel;
				}
				if (model) this.childrenModels.push(model);
			}
		}
		// non pour tags génériques inconnus voir wed dédié readonly .
		// if (this.colModels.length === 0) throw Error("No txt:column tag declared in wed: " + DOM.debug(cnf));
		// if (this.rowModels.length === 0) throw Error("No txt:row tag declared in wed " + DOM.debug(cnf));
	}

	get txtWedModels(): TxtModel[] {return this.childrenModels}

	protected newWedlet(): TxtElement {return new TxtTable()}
}

WED.registerWedletModel("TxtTable", TxtTableModel);

// ***** block slaves *****

/** sc:listItem */
export class TxtLIModel extends TxtContainerModel {
	protected newWedlet(): TxtElement {return new TxtLI()}
}

WED.registerWedletModel("TxtLI", TxtLIModel);

/** sc:member */
export class TxtMemberModel extends TxtParaModel {
	protected newWedlet(): TxtElement {return new TxtMember()}
}

WED.registerWedletModel("TxtMember", TxtMemberModel);

export class TxtTitleModel extends TxtParaModel {
	protected newWedlet(): TxtElement {return new TxtTitle()}
}

WED.registerWedletModel("TxtTitle", TxtTitleModel);

export class TxtCaptionModel extends TxtParaModel {
	protected newWedlet(): TxtElement {return new TxtCaption()}
}

WED.registerWedletModel("TxtCaption", TxtCaptionModel);


/** sc:col */
export class TxtColModel extends TxtModel {

	widthMgrLib: string;
	widthMgrKey: string;

	initModel(cnf: Element) {
		super.initModel(cnf);
		const widthMgr = cnf.getAttributeNS(TXT_NS, "widthMgr");
		if (widthMgr) {
			const offs = widthMgr.indexOf('.');
			if (offs > 0) {
				this.widthMgrLib = widthMgr.substring(0, offs);
				this.widthMgrKey = widthMgr.substring(offs + 1);
			}
		}
		if (!this.widthMgrLib) console.log("WidthMgr is required on table column definition: " + DOM.ser(cnf));
	}

	widthMgr(wedMgr: WedMgr): ITxtColWidthMgr {return wedMgr.wedModel.jsLibs[this.widthMgrLib][this.widthMgrKey]}

	get hasRefresh(): boolean {return this.widthMgrLib != null || this.refreshSvc != null || this.refreshLib != null}

	callRefresh(elt: TxtCol) {
		this.widthMgr(elt.wedMgr).refreshW(elt);
		if (this.refreshSvc || this.refreshLib) super.callRefresh(elt);
	}

	protected newWedlet(): TxtElement {return new TxtCol()}
}

WED.registerWedletModel("TxtCol", TxtColModel);

/** sc:row */
export class TxtRowModel extends TxtModel {
	cellModels: TxtCellModel[] = [];

	initModel(cnf: Element) {
		super.initModel(cnf);
		for (let ch = cnf.firstElementChild; ch; ch = ch.nextElementSibling) {
			if (ch.localName === 'cell' && ch.namespaceURI === TXT_NS) {
				const model = WED.buildBind(ch, 'TxtCell') as TxtCellModel;
				if (model) this.cellModels.push(model);
			}
		}
	}

	get txtWedModels(): TxtModel[] {return this.cellModels}

	protected newWedlet(): TxtElement {return new TxtRow()}
}

WED.registerWedletModel("TxtRow", TxtRowModel);

/** sc:cell */
export class TxtCellModel extends TxtContainerModel {

	spanMgrLib: string;
	spanMgrKey: string;

	initModel(cnf: Element) {
		super.initModel(cnf);
		const widthMgr = cnf.getAttributeNS(TXT_NS, "spanMgr");
		if (widthMgr) {
			const offs = widthMgr.indexOf('.');
			if (offs > 0) {
				this.spanMgrLib = widthMgr.substring(0, offs);
				this.spanMgrKey = widthMgr.substring(offs + 1);
			}
		}
	}

	get hasRefresh(): boolean {return this.spanMgrLib != null || this.refreshSvc != null || this.refreshLib != null}

	callRefresh(elt: TxtElement & TxtCell) {
		if (this.spanMgrLib) elt.spanMgr.refreshSpan(elt);
		if (this.refreshSvc || this.refreshLib) super.callRefresh(elt);
	}

	protected newWedlet(): TxtElement {return new TxtCell() as any as TxtElement}
}

WED.registerWedletModel("TxtCell", TxtCellModel);

/** sc:extBlock */
export class TxtObjectModel extends TxtModel {

	/** Affichage custom des diffs internes à cet objet (metas). */
	diffSvc: string;

	protected initDiff(tag: Element) {
		this.diffSvc = tag.getAttribute("svc");
	}

	protected newWedlet(): TxtElement {return new TxtObject()}

	addDiffCustom(elt: TxtObject, annot: ISkDiffAnnot): boolean {
		if (!this.diffSvc) return false;
		const diffCustom = REG.findReg(elt).getSvc(this.diffSvc) as ITxtAnnotDiff;
		if (diffCustom) {
			diffCustom.addDiff(elt, annot);
			return true;
		}
		console.log("ITxtAnnotDiff function not found. svc=" + this.diffSvc);
		return false;
	}

	removeDiffCustom(elt: TxtObject, annot: ISkDiffAnnot): boolean {
		if (!this.diffSvc) return false;
		const diffCustom = REG.findReg(elt).getSvc(this.diffSvc) as ITxtAnnotDiff;
		if (diffCustom) {
			diffCustom.removeDiff(elt, annot);
			return true;
		}
		return false;
	}
}

WED.registerWedletModel("TxtObject", TxtObjectModel);

/** sc:emptyBlock */
export class TxtEmptyModel extends TxtObjectModel {
	protected newWedlet(): TxtElement {return new TxtEmpty()}
}

WED.registerWedletModel("TxtEmpty", TxtEmptyModel);


// ***** inlines *****
export class InlPhraseModel extends InlineContentModel implements IInlWrapModel {
	get isInline() {return true}

	get splitPriority(): number {return 20};

	protected newWedlet(): TxtElement {return new InlPhrase()}
}

WED.registerWedletModel("InlPhrase", InlPhraseModel);

export class InlStyleModel extends InlineContentModel implements IInlWrapModel {
	get isInline() {return true}

	get splitPriority(): number {return 10};

	protected newWedlet(): TxtElement {return new InlStyle()}
}

WED.registerWedletModel("InlStyle", InlStyleModel);

export class InlLinkModel extends InlineContentModel implements IInlWrapModel {
	get isInline() {return true}

	get splitPriority(): number {return 30};

	protected newWedlet(): TxtElement {return new InlLink()}
}

WED.registerWedletModel("InlLink", InlLinkModel);

export class InlLeafModel extends TxtModel implements IInlWrapModel {
	get isInline() {return true}

	get splitPriority(): number {return 0};

	protected newWedlet(): TxtElement {return new InlLeaf()}

	get txtWedModels(): TxtModel[] {return this.txtRootModel ? [this.txtRootModel.strModel] : null}
}

WED.registerWedletModel("InlLeaf", InlLeafModel);

export class InlImgModel extends TxtModel {
	get isInline() {return true}

	protected newWedlet(): TxtElement {return new InlImg()}
}

WED.registerWedletModel("InlImg", InlImgModel);

export class InlObjectModel extends TxtModel {
	get isInline() {return true}

	protected newWedlet(): TxtElement {return new InlObject()}
}

WED.registerWedletModel("InlObject", InlObjectModel);

export class InlEmptyModel extends TxtModel {
	get isInline() {return true}

	protected newWedlet(): TxtElement {return new InlEmpty()}
}

WED.registerWedletModel("InlEmpty", InlEmptyModel);

export class InlNoteModel extends TxtContainerModel {
	protected newWedlet(): TxtElement {return new InlNote()}
}

WED.registerWedletModel("InlNote", InlNoteModel);

export class TxtStrModel extends TxtModel {

	/** Si true, réserve les espaces normaux en début et fin de noeud texte et la succession de plusieurs espaces. */
	keepSpaces = false;

	initModel(cnf: Element) {
		this.config = cnf;
		this.nodeLabel = cnf.getAttribute("label");
		//this.keepSpaces = cnf.getAttribute("keep-spaces") === "all"; utile ?
	}

	newJml(): IJmlNode {return ""}

	protected newWedlet(): TxtElement {return new TxtStr()}
}

WED.registerWedletModel("TxtStr", TxtStrModel);


/**
 * Modèle du txt-root : Propriétés ancrées sur l'élément txt-root du fichier WED
 * (donc mutualisées pour toutes les instances TxtRoot).
 */
interface ITxtRootModel {
	/** Balise <wed:children/> obligatoire dans le <txt-root/>. */
	wedChildrenElt: IWedChildrenElt

	/** Tous les modèles préférés de type block. */
	preferedBlockTxtModels: TxtModel[]

	/** Tous les modèles préférés de type inline. */
	preferedInlineTxtModels: TxtModel[]

	/** Modèle de paragraphe par défaut. */
	paraModel: TxtParaModel

	/** Modèle de noeud texte par défaut. */
	strModel: TxtStrModel
}

/**
 * Propriétés construites pour chaque IWedEditor (et son registre contextuel) et pour chaque modèle
 * de TxtRoot différents.
 * Objet enregistré auprès de WedMgr.getDatasForModel().
 */
interface ITxtRootProps extends IWedFocusBarPointer {

	/** Racourcis claviers de cet éditeur de texte. */
	accelKeyMgr: AccelKeyMgr<ITxtRootContext>

	/** Barre de menus de cet éditeur de texte. */
	focusBar: BarActions<ITxtRootContext>

	/** Barres de menus pour les tables de cet éditeur de texte (key = role de la table). */
	tableBars: Dict<BarActions<ITxtTableContext>>

	/** Traitements spéciaux lors de la saisie d'un texte à la volée. */
	onTypings: IOnTyping[]

	inlineMarkStyle: REG.SkinHolder
}

/** ActionContext pour les actions du wedlet de texte riche. */
export interface ITxtRootContext extends IAccelKeyMgrPointer<ITxtRootContext>, IRefreshHook, IWedletActionCtx, ISpellcheckContextPointer {

	accelKeyMgr?: AccelKeyMgr<ITxtRootContext>

	/** Ref au wedlet de texte. */
	txtRoot: TxtRoot
}

/** ActionContext pour les actions des tables du texte riche. */
export interface ITxtTableContext extends ITxtRootContext {
	txTable: TxtTable
	/** layout calculé une seule fois. */
	logicTable: TXTTABLE.LogicTable
}

/** Api pour ajouter des corrections automatiques, propositions de remplacement, etc.  pendant la saisie. */
export interface IOnTyping {

	/** Libellé de ce onTyping pour ihm d'activation / désactivation par le user. */
	label: string

	/**
	 * Fonction d'exécution de l'auto-correction.
	 * Il est fortement conseillé de n'utiliser que les params suivants :
	 * - ev.data : texte inséré.
	 * - beforeXmlText : texte avant l'insertion.
	 * - xmlOffset : offset de l'insertion de ev.data dans text.
	 * - fullXmlText : noeud texte déjà modifié avec ev.data inséré.
	 * - lang : langue courante issu du contexte du noeud.
	 * Retourne true si une auto-correction a eu lieu, les 'onTypings' suivants sont abandonnés.
	 */
	onTyping(ev: InputEvent, root: TxtRoot, txtStr: TxtStr, lang: string, beforeXmlText: string, xmlOffset: number, fullXmlText: string): boolean

}

/**
 * Factory d'un IOnTyping permettant d'être personnalisé par configuration XML (issu du fichier wed)
 * et par le contexte de l'editeur dans lequel il est exploité.
 */
export interface IOnTypingFactory {

	buildOnTyping(wedMgr: WedMgr, config?: Element): IOnTyping
}

function isOnTypingFactory(ot: any): ot is IOnTypingFactory {return ot && ('buildOnTyping' in ot)}

function findOnTyping(def: Element, reg: IReg<any>): IOnTyping | IOnTypingFactory {
	const svcCode = def.getAttribute('svc');
	if (svcCode) {
		const ot = reg.getSvc(svcCode) as IOnTyping | IOnTypingFactory;//FIXME !!!!
		if (isOnTypingFactory(ot)) return new OnTypingFromSvc(ot, def);
		return ot;
	}
	const lib = def.getAttribute('lib');
	return lib ? new OnTypingFromLib(lib, def.getAttribute('identifier'), def) : null;
}

/**
 * Recherche du IOnTyping dans les libs du wedModel et le contruit si c'est une factory.
 */
class OnTypingFromLib implements IOnTypingFactory {
	constructor(public lib: string, public identifier: string, public config: Element) {}

	buildOnTyping(wedMgr: WedMgr, config?: Element): IOnTyping {
		const lib = wedMgr.wedModel.jsLibs[this.lib];
		if (!lib || !(this.identifier in lib)) return null;
		const ot = lib[this.identifier];
		return isOnTypingFactory(ot) ? ot.buildOnTyping(wedMgr, this.config) : ot;
	}
}

/** Configure un OnTyping et le construit en fonction du contexte son IEditor. */
class OnTypingFromSvc implements IOnTypingFactory {
	constructor(public ot: IOnTypingFactory, public config: Element) {}

	buildOnTyping(wedMgr: WedMgr, config?: Element): IOnTyping {
		return this.ot.buildOnTyping(wedMgr, this.config);
	}
}

/**
 * Interface commune à TxtRoot et TxtElement.
 */
export interface ITxtElement extends IElementWedlet {

	/** Racine de l'éditeur de texte. */
	txtRoot: TxtRoot;

	wedAnchor: IXAddr;

	/** Liste des modèles fils préférés à ce niveau. */
	txtWedModels: TxtModel[];

	/**
	 * Retourne le modèle de wedlet préféré pour ce tag fis. A utiliser par les actions pour interroger la structure des wedlets.
	 * Ne retourne pas les modèles issus du registre central pour les structures inconnues.
	 * Les Wedlets Txt imposent de déclarer explicitement toutes les structures du schéma manipulables par les actions.
	 */
	getTxtWedModel(tagName: string, role: string): TxtModel;

	/** Modèle de paragraphe par défaut. */
	paraModel: TxtParaModel;

	/** Modèle de noeud texte par défaut. */
	strModel: TxtStrModel;

	isTextContainer: boolean;

	/** Abstrait la différence d'impl nécessaire entre les fils du root et les autres. */
	insertVirtualPara(before: Node, regularDisplay?: boolean): TxtPara;

	/** Abstrait la différence d'impl nécessaire entre les fils du root et les autres. */
	insertVirtualStr(before: Node): void;
}

/**
 * Element racine d'une édition de texte riche.
 * Cet élement peut-être associé à n'importe quel IWedlet (de type Box par exemple).
 * Le wedlet associé doit binder l'élément racine de la textPrim, les noeuds fils étant
 * des noeuds de type block (para, table, list, emptyBlock...).
 *
 * Attention, le txtRoot doit déclarer explicitement tous les éléments blocks et inline connus du schéma.
 * L'utilisation du registre central est limité aux balises inconnues.
 *
 * Attributs :
 * - stretch="vertical" Mode particulier où le texte est le seul élément de l'éditeur et doit s'étendre sur toute la hauteur disponible.
 * - placeholder : Texte affiché par défaut.
 * - placeholderup="1" : Recherche l'attribut placeholder dans l'élément racine du wedlet parent, ou grand-parent (placeholderup="2"), etc.
 *   autres valeurs :
 *      down:4    premier placeholder non vide en partant de la position 4, et en redescendant jusqu'à la position courant
 *      down:4:2  premier placeholder non vide en partant de la position 4, et en redescendant jusqu'à la position 2
 *      up:2:4    premier placeholder non vide en partant de laposition 2, et en remontant jusqu'à la position 4
 * - mono-para="" Indique qu'on est mode mono-para pour une gestion correcte du placeholder même si le para est obligatoire dans le schéma.
 *
 * Stylage du placeholder :
 * :not(:focus) > txt-para[placeholder].virtual:only-of-type::before,
 * [mono-para]:not(:focus) > txt-para > txt-str[placeholder].virtual:only-of-type::before {
 * 	...
 * }
 */
export class TxtRoot extends HTMLElement implements ITxtElement, IFixCaret, IFixSelection, IWedFocusBarPointer, IContextMenuActionsPointer<ITxtRootContext>, ITxtRootContext, IEltBoxSelection, ICustomClipboard, CustomElement {

	/**
	 * Permet d'imposer le selector de type Txt pour <wed:children/> inclut dans la balise <txtRoot/> qui restreint
	 * aux modèles de wedlet de type TxtModel et qui matchent le même role.
	 *
	 * @see {IWedSelectorFactory}
	 */
	static buildWedSelector(elt: Element): IWedSelector {
		return TxtModel.wedSelector;
	}

	wedlet: IParentWedlet & IWedletSingleElt;

	wedMgr: WedMgr;

	get wedAnchor(): IXAddr {return this.wedlet.wedAnchor}

	/** Méthode commune avec TxtElement pour retrouver la racine (et servir son propre contexte ITxtRootContext). */
	get txtRoot(): TxtRoot {return this}

	/** this est vu comme son propre ITxtRootContext au keypress (accelKeyMgr) */
	get focusedElt(): HTMLElement {return this}

	get isTextContainer() {return false}

	get isMonoPara() {return false}

	/**
	 * Gestionnaire de sélection dans le texte.
	 * Cet accesseur doit etre utilisé par défaut car il fixe les erreurs de positionenement de sélection
	 * et retourne une version figée lors d'un cycle de refresh des actions (voir IRefreshHook.onRefreshCycle().
	 */
	get selMgr(): TxtSelMgr {
		if (this._selMgrFrozen) return this._selMgrFrozen;
		this.selMgrAsIs.fixupSel();
		return this.selMgrAsIs;
	}

	protected _selMgrFrozen: TxtSelMgrFrozen;

	/**
	 * Gestionnaire de sélection dans le texte sans correction préalable.
	 */
	selMgrAsIs: TxtSelMgr;

	beforeInputHandler: Dict<(this: void, ev: InputEvent, root: TxtRoot) => void>;
	keyPressHandler: Dict<(this: void, ev: KeyboardEvent, root: TxtRoot) => void>;
	keyDownHandler: Dict<(this: void, ev: KeyboardEvent, root: TxtRoot) => void>;

	constructor() {
		super();
		this.addEventListener("focusin", this.onFocusin);
		this.addEventListener("blur", this.onBlur);
		this.addEventListener("keydown", this.onKeyDown);
		this.addEventListener("keypress", this.onKeyPress);
		this.addEventListener("compositionstart", this.onCompositionStart);
		this.addEventListener("compositionupdate", this.onCompositionUpdate);
		this.addEventListener("compositionend", this.onCompositionEnd);
		this.addEventListener("beforeinput", this.onBeforeinput);
		this.addEventListener("dragstart", this.onDragstart);
		this.addEventListener("drop", this.onDrop);
		this.addEventListener("click", this.onClick);
		this.addEventListener("paste", this.onPasteFiles); //Pour paste de fichiers externes

		//Obligatoire sinon le navigateur trafique les espaces (32) et les espaces inséccables (160).
		//exemple de bug :
		//Noeud texte: "aa bb cc", sel de [bb], frappe de 'x' : coté XML on a "aa x cc", mais coté web on a "aa xcc"
		//car à la suppr de [bb], un état intermédiaire est "aa  cc" et ce double espace est parfois supprimé,
		//mais pas toujours, si on passe en debug par ex il ne l'est plus, probablement lié à la perte du focus...
		this.style.whiteSpace = "pre-wrap";
		//this.style.userSelect = "text"; //utile pour sélectionner le texte même si widget passé en readonly contentEditable=false.

		this.beforeInputHandler = beforeInputHandler;
		this.keyPressHandler = keyPressHandler;
		this.keyDownHandler = keyDownHandler;
	}

	connectedCallback() {
		if (this.wedlet.wedParent?.model.nodeType !== ENodeType.element || this.getAttribute("stretch") === 'vertical') {
			//Mode particulier où le texte est le seul élément de l'éditeur, fils direct du bind document / documentFragment racine de l'éditeur.
			// et doit s'étendre sur toute la hauteur disponible
			//hack le display / flex jusqu'au wedEditor.rootNode inclus.
			const st = this.style;
			st.flex = "1";
			let n = DOMSH.getFlatParentElt(this) as HTMLElement;
			const root = this.wedMgr.wedEditor.rootNode;
			while (n) {
				const st = n.style;
				st.flex = "1";
				st.display = "flex";
				st.flexDirection = "column";
				st.padding = "0";
				if (n === root) break;
				st.border = "none"; //pb avec le scroll
				n = DOMSH.getFlatParentElt(n) as HTMLElement;
			}
		}
	}

	wedConfig: Element & ITxtRootModel;

	/**
	 * Modèles explicitement préférés pour cet éditeur.
	 */
	get txtWedModels(): TxtModel[] {return this.wedConfig.wedChildrenElt.wedPreferedModels as TxtModel[]}

	get paraModel(): TxtParaModel {return this.wedConfig.paraModel}

	get strModel(): TxtStrModel {return this.wedConfig.strModel}

	getTxtWedModel(tagName: string, role: string): TxtModel {
		if (role == null) role = "";
		for (const txtModel of this.txtWedModels) if (txtModel.nodeName === tagName && txtModel.role === role) return txtModel;
		return null;
	}

	insertVirtualPara(before: Node, regularDisplay?: boolean): TxtPara {
		const paraModel = this.paraModel;
		if (!paraModel) return null;
		const childrenElt = this.wedConfig.wedChildrenElt;
		const para = paraModel.createWedlet(this.wedlet, childrenElt.wedDefaultDisplay) as TxtPara;
		para.configWedletElt(paraModel.config, para);
		if (childrenElt.wedSlotName) {
			//para à la racine du TxtRoot.
			para.setAttribute("slot", childrenElt.wedSlotName);
			if (!this.hasAttribute("mono-para")) evalPlaceHolder(this, para);
		}
		(para as IElementWedlet).fromChildrenElt = childrenElt;
		if (regularDisplay) para.className = "regular";
		this.insertBefore(para, before) as TxtElement;
		return para.bindAsVirtual();
	}


	insertVirtualStr(before: Node) {
		console.trace("Should not be called!!");
	}

	onRefreshCycle(before: boolean): 'stop' | void {
		//console.error("onRefreshCycle", before);
		if (before) {
			if (!(this.selMgrAsIs.focusNode || this).isConnected) return 'stop';
			if (0 === this._RefreshCycle++) this._selMgrFrozen = new TxtSelMgrFrozen(this.selMgrAsIs/*selMgrAsIs sinon casse la sel par drag&drop. */);
		} else if (this._RefreshCycle > 0) {
			if (--this._RefreshCycle === 0) this._selMgrFrozen = null;
		}
	}

	unfreezeSel() {
		this._RefreshCycle = 0;
		this._selMgrFrozen = null;
	}

	protected _RefreshCycle = 0;

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		this.wedlet = wedlet as IParentWedlet & IWedletSingleElt;
		this.wedMgr = wedlet.wedMgr;
		this.selMgrAsIs = new (this.wedMgr.reg.getSvc<typeof TxtSelMgr>("wedTxtSelMgrClass") || TxtSelMgr)(this);
		this.contentEditable = WEDLET.isWritableWedlet(this.wedlet) ? 'true' : 'false';
		this.wedConfig = tpl as Element & ITxtRootModel;
		//txt-root est obligatoirement le host des balises txt filles, sinon le mécanime de sélection inter-blocks
		//du navigateur ne fonctionne pas.
		this.wedlet.element.setDelegatedHost(this);
		if (!this.wedConfig.wedChildrenElt) {
			//modèle jamais initialisé.
			for (let ch = this.wedConfig.firstElementChild; ch; ch = ch.nextElementSibling) {
				if (isWedChildrenElt(ch)) {
					if (this.wedConfig.wedChildrenElt) throw Error("'wed:children' found twice in txt-root wed: " + DOM.debug(this.wedConfig));
					this.wedConfig.wedChildrenElt = ch;
					this.wedConfig.preferedBlockTxtModels = [];
					this.wedConfig.preferedInlineTxtModels = [];
					const childrenModels = this.wedConfig.wedChildrenElt.wedPreferedModels;
					if (childrenModels) for (const model of childrenModels) this._indexModel(model as TxtModel);
					const descendants = DOM.findFirstChild(this.wedConfig, (n => n.localName === 'descendants') as INodeFilter<Element>);
					if (descendants) for (let bind = descendants.firstElementChild; bind; bind = bind.nextElementSibling) {
						this._indexModel(WED.buildBind(bind) as TxtModel);
					}
					if (!this.wedConfig.strModel) this.wedConfig.strModel = this.wedMgr.wedModel.findModelForVirtual(ENodeType.text, null, null, null, this.wedlet, TxtModel.wedSelector, null) as TxtStrModel;
				}
			}
			if (!this.wedConfig.wedChildrenElt) throw Error("No 'wed:children' tag found in txt-root wed: " + DOM.debug(this.wedConfig));
		}
		const inlineMarks = this.wedMgr.reg.getUserData("wedTxtInlineMarkers", false);
		if (inlineMarks) this.inlineMarkers = true;
	}

	get txtRootProps(): ITxtRootProps {
		const props = this.wedMgr.getDatasForModel(this.wedConfig) as ITxtRootProps;
		if (props.onTypings !== undefined) return props;
		//jamais initialisé pour ce modèle de textRoot dans le contexte de cet éditor.
		let onTypings: (IOnTyping | IOnTypingFactory)[];
		let focusBarActions: ITxtAction<ITxtRootContext>[];
		const tableBarsActions: Dict<ITxtAction<ITxtTableContext>[]> = {};
		const subReg = REG.createSubReg(REG.findReg(this));
		props.accelKeyMgr = new AccelKeyMgr<ITxtRootContext>();
		props.accelKeyMgr.addAccelKey("c", "accel", copyDefault);
		props.accelKeyMgr.addAccelKey("c", "accel,shift", copyAsXml);
		props.accelKeyMgr.addAccelKey("x", "accel", cutDefault);
		props.accelKeyMgr.addAccelKey("v", "accel", pasteDefault);
		props.accelKeyMgr.addAccelKey("v", "accel,shift", pasteAsText);
		props.accelKeyMgr.addAccelKey("v", "accel,shift,alt", pasteAsString);

		for (let ch = this.wedConfig.firstElementChild; ch; ch = ch.nextElementSibling) {
			if (ch.localName === 'uiconfig') {
				for (let conf = ch.firstElementChild; conf; conf = conf.nextElementSibling) {
					if (conf.namespaceURI !== TXT_NS) continue;
					if (conf.localName === 'accelKeys') {
						const list = split(conf.getAttribute("lists"));
						if (list) {
							for (let defKey = conf.firstElementChild; defKey; defKey = defKey.nextElementSibling) {
								if (defKey.localName === 'accelKey') subReg.addToList(
									list[0],
									defKey.getAttribute('key') + '-' + (defKey.getAttribute('modifiers') || "accel"),
									REG.LEVELAUTH_MODEL,
									createTxtAction(defKey.firstElementChild, defKey.getAttribute('actionId'), subReg, false)
								);
							}
							props.accelKeyMgr.initFromMapActions(subReg.mergeListsAsMap(...list));
						} else {
							for (let bind = conf.firstElementChild; bind; bind = bind.nextElementSibling) {
								if (bind.localName === 'accelKey') {
									props.accelKeyMgr.addAccelKey(bind.getAttribute('key'), bind.getAttribute('modifiers') || "accel", createTxtAction(bind.firstElementChild, bind.getAttribute('actionId'), subReg, false));
								}
							}
						}
					} else if (conf.localName === 'toolbar') {
						const list = split(conf.getAttribute("lists"));
						let actions: IAction<ITxtRootContext>[] = list ? null : [];
						for (let btn = conf.firstElementChild; btn; btn = btn.nextElementSibling) {
							if (btn.localName === 'button') {
								const id = btn.getAttribute('actionId');
								const action = createTxtAction<ITxtRootContext>(btn.firstElementChild, id, subReg, true, list);
								if (actions && action) actions.push(action);
							}
						}
						if (list) actions = subReg.mergeLists(...list);
						// actions.push(TxtEraseDiffSel.SINGLETON);
						// focusBarActions = ACTION.injectSepByGroup(actions, "", this) as ITxtAction<ITxtRootContext>[];
						focusBarActions = actions.length > 0 ? ACTION.injectSepByGroup(actions, "", this) as ITxtAction<ITxtRootContext>[] : null;
					} else if (conf.localName === 'tableToolbar') {
						const list = split(conf.getAttribute("lists"));
						let actions: ITxtAction<ITxtTableContext>[] = list ? null : [];
						for (let btn = conf.firstElementChild; btn; btn = btn.nextElementSibling) {
							if (btn.localName === 'button') {
								const id = btn.getAttribute('actionId');
								const action = createTxtAction<ITxtTableContext>(btn.firstElementChild, id, subReg, true, list);
								if (actions && action) actions.push(action);
							}
						}
						if (list) actions = subReg.mergeLists(...list);
						tableBarsActions[conf.getAttribute("role") || ""] = actions.length > 0 ? actions : null;
					} else if (conf.localName === 'onTypings') {
						const list = split(conf.getAttribute("lists"));
						if (list) {
							//config avec surcharge de la 1ère liste configurée
							for (let otElt = conf.firstElementChild; otElt; otElt = otElt.nextElementSibling) {
								if (otElt.localName === 'onTyping') subReg.addToList(list[0], otElt.getAttribute('otId'), REG.LEVELAUTH_MODEL, findOnTyping(otElt, subReg));
							}
							onTypings = subReg.mergeLists(...list);
						} else {
							//config simple : liste de base (non surchargeable/annulable) + ajout d'autres onTyping.
							onTypings = subReg.getList("wed:text:onTyping");
							for (let otElt = conf.firstElementChild; otElt; otElt = otElt.nextElementSibling) {
								if (otElt.localName === 'onTyping') {
									const ot = findOnTyping(otElt, subReg);
									if (ot) onTypings.push(ot);
								}
							}
						}
					} else if (conf.localName === 'inlineMarkerStyle') {
						subReg.registerSkin("txt-root/InlineMarker", REG.LEVELAUTH_MODEL, conf.textContent);
					}
				}
			}
		}
		//config par défaut.
		if (!onTypings) onTypings = REG.findReg(this).getList("wed:text:onTyping");
		//construction des objets finaux.
		if (!onTypings) {
			props.onTypings = null;
		} else {
			//TODO config personnelle de restriction des onTypings activés (via userDataStore).
			props.onTypings = [];
			for (let i = 0; i < onTypings.length; i++) {
				let ot = onTypings[i];
				if (isOnTypingFactory(ot)) ot = ot.buildOnTyping(this.wedMgr);
				if (ot) props.onTypings.push(ot);
			}
		}
		//On impose toujours une focusBar, même vide pour éviter d'avoir une barre du contexte Box inappropriée.
		props.focusBar = new BarActions<ITxtRootContext>().initialize({
			actions: focusBarActions || [],
			actionContext: new WedTxtRootCtx(this)
		});
		for (const k in tableBarsActions) {
			if (!props.tableBars) props.tableBars = {};
			props.tableBars[k] = new BarActions<ITxtTableContext>().initialize({
				actions: tableBarsActions[k],
				actionContext: new WedTxtRootCtx(this)
			});
		}
		props.inlineMarkStyle = subReg.getSvc(REG.SKIN_PREFIX + "txt-root/InlineMarker");
		return props;
	}

	protected _indexModel(model: TxtModel) {
		if (model instanceof TxtStrModel) {
			this.wedConfig.preferedInlineTxtModels.push(model);
			if (!model.role) this.wedConfig.strModel = model;
		} else if (model.isInline) {
			this.wedConfig.preferedInlineTxtModels.push(model);
		} else {
			this.wedConfig.preferedBlockTxtModels.push(model);
			if (model instanceof TxtParaModel && !model.role) this.wedConfig.paraModel = model;
		}
	}

	refreshBindValue(val: IJmlNode | string) {
		//this.wedlet.isVirtual() ? this.classList.add("virtual") : this.classList.remove("virtual");
		if (this.wedlet.isVirtual()) removeAnnots(this);
	}

	setEditMode(mode: EWedletEditMode) {
		this.contentEditable = mode === EWedletEditMode.write ? 'true' : 'false';
		DOM.setAttr(this, "edit-mode", EWedletEditModeLabel[mode]);
	}

	onChildWedletsChange() {
		adjustVirtualsPara(this);
		if (this.hasAttribute("mono-para")) {
			const para = findTxtEltFirstChild(this);
			if (para) evalPlaceHolder(this, para.findOrCreateTxtStr(false));
		}
	}

	/** api IAccelKeyMgrPointer */
	get accelKeyMgr(): AccelKeyMgr<ITxtRootContext> {return this.txtRootProps.accelKeyMgr};

	get onTypings(): IOnTyping[] {return this.txtRootProps.onTypings}

	get inlineMarkers(): boolean {
		const styleDef = this.txtRootProps.inlineMarkStyle;
		if (!styleDef) return false;
		const style = styleDef.getSkinIfExist(DOMSH.findDocumentOrShadowRoot(this));
		return style ? !style.disabled : false;
	}

	set inlineMarkers(val: boolean) {
		const styleDef = this.txtRootProps.inlineMarkStyle;
		if (!styleDef) return;
		if (!('showTxtStackBar' in this.wedMgr.wedEditor)) return;
		const shRoot = DOMSH.findDocumentOrShadowRoot(this);
		const style = styleDef.getSkinIfExist(shRoot);
		if (style) {
			style.disabled = !val;
		} else {
			if (val) styleDef.installSkin(shRoot);
		}
		if (val) (this.wedMgr.wedEditor as IWedEditorTxtSel).showTxtStackBar();
		else (this.wedMgr.wedEditor as IWedEditorTxtSel).hideTxtStackBar();
	}

	storeInlineMarkers() {
		const persist = this.wedMgr.reg.getPersistUserStates();
		if (persist) persist.setUserDatas({"wedTxtInlineMarkers": this.inlineMarkers});
	}

	get focusBar(): BarActions<ITxtRootContext> {
		const bar = this.txtRootProps.focusBar;
		if (bar) bar.actionContext.focusedElt = this;
		return bar;
	}

	get ctxMenuActions(): IContextMenuActions<ITxtRootContext> {
		const bar = this.focusBar;
		const actions: IAction<ITxtRootContext>[] = Desk.electron && this.contentEditable === "true" ? [spellcheckMenu, hintsMenu, ...copyPasteMenus] : [hintsMenu, ...copyPasteMenus];
		let actionContext: ITxtRootContext;
		if (bar) {
			actions.push(new ActionSeparator(), ...bar.actions);
			actionContext = bar.actionContext;
		} else {
			actionContext = new WedTxtRootCtx(this);
		}
		actionContext.focusedElt = this;
		return {actionContext, actions};
	}

	handleEventFromContainer(ev: KeyboardEvent | MouseEvent) {
		this.selMgr.selectAll();
		if (ev instanceof KeyboardEvent && ev.key.length === 1 && this.contentEditable) {
			this.doPaste("string", null, [new ClipboardItem({"text/plain": ev.key})]);
		}
	}

	onFocusin(ev: FocusEvent) {
		this.selMgrAsIs.onFocus(ev);
	}

	onBlur(ev: FocusEvent) {
		this.selMgrAsIs.onBlur(ev);
	}

	/** Noeud texte sur lequel une composition IME est en cours. */
	pendingIme?: ITxtStrTextNode;

	/**
	 * Indique pendant une transaction que la modification HTML a déjà eu lieu.
	 * Obligatoire pour édition IME ou beforeinput event non cancelable.
	 * L'html n'est alors pas modifié et la selection n'est pas gérée par le txtSelMgr.
	 */
	webUpdateDone?: boolean;

	onCompositionStart(ev: CompositionEvent) {
		//console.log(":onCompositionStart::", ev, ev.composedPath()[0], ev.cancelable);
		const selMgr = this.selMgr;
		if (selMgr.type !== "Caret") deleteFromSel(this, false, "character");
		const textNode = selMgr.focusNode as ITxtStrTextNode;
		const txtStr = findTxtStrParent(selMgr.focusNode);
		textNode.ime = {start: selMgr.focusOffset, len: 0};
		this.pendingIme = textNode;
	}

	onCompositionUpdate(ev: CompositionEvent) {
		//console.log(":onCompositionUpdate::", ev.data);
		this.pendingIme.ime.len = ev.data.length;
	}

	onCompositionEnd(ev: CompositionEvent) {
		//console.log(":onCompositionEnd::", ev, ev.cancelable);
		if (ev.data) {
			this.webUpdateDone = true;
			doInput(ev.data, ev, this);
			this.webUpdateDone = false;
		}
		this.pendingIme.ime = null;
		this.pendingIme = null;
	}

	onBeforeinput(ev: InputEvent) {
		const type = ev.inputType;
		if (type in this.beforeInputHandler) this.beforeInputHandler[type](ev, this);
		else if (ev.cancelable) ev.preventDefault(); // notamment pour historyUndo, historyRedo
		//console.log("beforeinput::::", ev, ev.cancelable, ev.defaultPrevented);
	}

	onKeyPress(ev: KeyboardEvent) {
		//console.log("keypress txt-root::::", ev);
		const key = ev.key;
		if (key in this.keyPressHandler) this.keyPressHandler[key](ev, this);
	}

	onKeyDown(ev: KeyboardEvent) {
		//console.log("keydown txt-root::::", ev);
		//force un fixupSel pour une insertion correcte.
		if (this.accelKeyMgr && (ev.ctrlKey || ev.metaKey || ev.altKey)) {
			if (this.accelKeyMgr.handleKeyboardEvent(ev, this) === 2) return;
		}
		const key = ev.key;
		if (key in this.keyDownHandler) this.keyDownHandler[key](ev, this);
	}

	onClick(ev: MouseEvent) {
		if (ev.defaultPrevented) return; //Si un sous-noeud a déjà géré la sel, on sort.
		if (ev.detail === 2) {
			//Double-click = sel du mot : on contre le comportement de Chrome au "select word" par double-click qui sélectionne l'espace après le mot.
			//ev.preventDefault(); //dans chrome la sel du mot au triple click se fait avant, preventDefault() n'a aucun effet.
			this.selMgr.trim();
		} else if (ev.detail === 3) {
			//Triple-click = sel du paragraphe : on contre le comportement de Chrome, pas satisfaisant.
			//ev.preventDefault(); //dans chrome la sel du para au triple click se fait avant, preventDefault() n'a aucun effet.
			const selMgr = this.selMgr;
			const from = findTxtParaLikeFrom(selMgr.focusNode);
			if (from) selMgr.selectAround(from);
		}
	}

	async onClipboard(act: "copy" | "cut" | "paste", ev?: Event, options?: Dict<any>): Promise<boolean> {
		switch (act) {
		case "copy":
			await this.onCopy(ev);
			break;
		case "cut":
			await this.onCut(ev);
			break;
		case "paste":
			await this.onPaste(ev);
			break;
		}
		return true;
	}

	async onCopy(ev?: Event) {
		const selMgr = this.selMgr;
		if (selMgr.tableLayout) selMgr.tableLayout.onCopy(ev);
		else return this.wedMgr.writeRangeToClipboard(selMgr.getXaRange() || /* sel none */ XA.newRangeAround(this.wedAnchor));
	}

	async onCut(ev: Event): Promise<void> {
		if (!WEDLET.isWritableWedlet(this.wedlet)) return;
		const selMgr = this.selMgr;
		if (selMgr.tableLayout) selMgr.tableLayout.onCut();
		else {
			await this.wedMgr.writeRangeToClipboard(selMgr.getXaRange());
			deleteFromSel(this, false, 'character');
		}
	}

	async onPaste(ev?: Event) {
		return this.doPaste(undefined);
	}

	async onPasteFiles(ev: ClipboardEvent) {
		//On bloque toutes les actions standard dans l'éditeur.
		ev.preventDefault();
		if (ev.clipboardData.files?.length > 0) {
			ev.stopPropagation();
			return this.doPaste(undefined, ev.clipboardData);
		}
	}

	/**
	 *
	 * @param trsfFiles Uniquement si trsfFiles.files non null (import de fichiers externes)
	 * @param clipboardItems Si déja extrait (voir pré-transformé) du clipboard.
	 */
	async doPaste(targetHint?: "string" | "text" | "markdown" | undefined, trsfFiles?: DataTransfer, clipboardItems?: ClipboardItem[]) {
		if (!WEDLET.isWritableWedlet(this.wedlet)) return;
		if (!trsfFiles && !clipboardItems) {
			clipboardItems = await WEDLET.readClipboard();
			if (!clipboardItems || clipboardItems.length === 0) return;
		}
		let selMgr = this.selMgr;
		const txtElt = findTxtEltOrRootParent(selMgr.commonAncestor, true);
		if (!txtElt) return;
		//if (txtElt instanceof TxtStr && txtElt.isVirtual()) txtElt = findTxtEltOrRootParent(txtElt); // pour être en phase avec selMgr.getXaRange()
		const wedMgr = this.wedMgr;
		const txStamp = wedMgr.txStamp;
		let impCtx = this.buildImportContext(txtElt, selMgr, targetHint);
		if (!impCtx) return;
		let imports: ISkImporter[];
		imports = trsfFiles ? await wedMgr.tryPasteFiles(impCtx, {}, trsfFiles) : await wedMgr.tryPaste(impCtx, {}, clipboardItems);
		if (!imports || imports.length === 0) {
			POPUP.showNotifInfo("Aucun contenu du presse-papier n'a pu être importé.", this);
		} else {
			const doImport = async (importer: ISkImporter) => {
				if (importer.needAsyncBuild && await importer.buildContentToImport(this) === 'stop') return;
				if (txtElt.isConnected) {
					//on est toujours connecté
					if (txStamp !== wedMgr.txStamp) {
						//des modif concurentes ont eu lieu (pendant l'async de tryPaste() et buildContentToImport())
						// => on reset le contexte pour forcer le recalcul.
						selMgr = this.selMgr;
						impCtx = this.buildImportContext(txtElt, selMgr, targetHint);
						if (!impCtx) return;
					}
					if (this.wedlet.isVirtual()) {
						const batch = wedMgr.docHolder.newBatch();
						importer.doImport(impCtx, batch);
						try {
							wedMgr.freezeFocus = true;
							batch.doBatch();
							if (txtElt.isConnected) {
								const str = findTxtStrLastChild(this);
								this.selMgr.setCaretAtEnd(str);
							}
						} finally {
							wedMgr.freezeFocus = false;
						}
					} else {
						const sel = selMgr.getXaRange();
						const batch = wedMgr.docHolder.newBatch(sel);
						batch.setMeta("from", "paste");
						if (selMgr.type === "Object") {
							batch.setSelBefore(sel.start); //améliore la sel sur undo : l'obj est alors focusé, car sel autour d'un object n'est pas visible actuellement.
						}
						importer.doImport(impCtx, batch);
						batch.doBatch();
					}
				}
			};
			if (imports.length === 1) {
				doImport(imports[0]);
			} else {
				const actions = imports.map((imp) => new Action().setLabel(imp.getLabel()).setExecute(() => {doImport(imp)}));
				if (selMgr.tableLayout) {
					selMgr.tableLayout.locked = true;
					try {
						POPUP.showPopupActions({actions, restoreFocus: selMgr.tableLayout.tblEditNode}, selMgr.tableLayout.focusCell, this);
					} finally {
						selMgr.tableLayout.locked = false;
					}
				} else {
					POPUP.showPopupActions({actions}, txtElt, this);
				}
			}
		}
	}

	protected buildImportContext(txtElt: TxtElement | TxtRoot, selMgr: TxtSelMgr, targetHint?: "string" | "text" | "markdown" | undefined): OSkPasteContext {
		if (selMgr.tableLayout) return selMgr.tableLayout.buildImportContext();
		return {sel: selMgr.getXaRange(true), virtualPath: WEDLET.buildVirtualPath(txtElt.wedlet), targetHint};
	}

	onDragstart(ev: DragEvent) {
		// console.log("drastart::::", ev);
		// ev.dataTransfer.setData('text/scenari', 'Scenarischema!');
		// ev.dataTransfer.setData('text/plain', 'Scenarischema! en textPlain');
		// ev.dataTransfer.setData('text/html', '<span>coucou</span>');
		ev.preventDefault();
		ev.stopImmediatePropagation();
	}

	onDrop(ev: DragEvent) {
		//console.log("drop::::", ev, ev.dataTransfer.getData('text/scenari'));
		ev.preventDefault();
	}

	/**
	 * Si le caret est en dehors d'un TxtStr -sinon cette méthode n'est pas appelée car
	 * le TxtStr aura pris le fixupCaret()-, on cherche à le repositionner dans un TxtStr.
	 */
	fixupCaret(selMgr: TxtSelMgr): boolean {
		let node = selMgr.focusNode as Node;
		node = node.childNodes[selMgr.focusOffset] || node.lastChild || node;
		// console.log("fixupCaret:::", node);
		// if(node instanceof HTMLElement && node.tabIndex >= 0) return;
		let txtStr = findTxtStrPrevious(node);
		if (txtStr) {
			txtStr.setCaretIn(selMgr, false);
			return true;
		}
		txtStr = findTxtStrNext(node);
		if (txtStr) {
			txtStr.setCaretIn(selMgr, true);
			return true;
		}
		console.log("TxtRoot.fixupCaret(sel) fail to find a TxtStr.");
		return false;
	}

	/**
	 * Si le focusNode ou le anchorNode est en dehors d'un TxtStr -sinon cette méthode n'est pas appelée car
	 * le TxtStr aura pris le fixupSelection()-, on cherche à le repositionner dans un TxtStr.
	 * On privillégie la réduction de la sélection.
	 */
	fixupSelection(selMgr: TxtSelMgr, what: number, oldFocus: Node, oldOffset: number): boolean {
		const range = selMgr.range;
		if (what & 1) {
			const anchorNode = selMgr.anchorNode;
			const child = anchorNode.childNodes[selMgr.anchorOffset];
			if (range.startContainer === anchorNode) {
				//anchorNode est avant le focus => on cherche un text après de préférence
				let txtStr = findTxtStrNext(child || DOM.findNextUncle(anchorNode, this));
				if (txtStr) {
					const node = DOM.findNext(txtStr, txtStr, DOM.IS_text) as ITxtStrTextNode; // : DOM.findPreviousIn(txtStr, DOM.IS_text);
					selMgr.setSelAnchor(node, node.startBoundary ? 1 : 0);
				} else {
					txtStr = findTxtStrPrevious(child || anchorNode.lastChild || anchorNode);
					if (txtStr) {
						const node = DOM.findPreviousIn(txtStr, DOM.IS_text) as ITxtStrTextNode;
						selMgr.setSelAnchor(node, node.endBoundary ? node.length - 1 : node.length);
					} else {
						console.log("fixupSelection : no txtStr Found (1)");
					}
				}
			} else {
				//anchorNode est après le focus => on cherche un text avant de préférence
				let txtStr = child ? findTxtStrPrevious(child) : findTxtStrLastChild(anchorNode) || findTxtStrPrevious(anchorNode);
				if (txtStr) {
					const node = DOM.findPreviousIn(txtStr, DOM.IS_text) as ITxtStrTextNode;
					selMgr.setSelAnchor(node, node.endBoundary ? node.length - 1 : node.length);
				} else {
					txtStr = findTxtStrNext(child || DOM.findNextUncle(anchorNode, this));
					if (txtStr) {
						const node = DOM.findNext(txtStr, txtStr, DOM.IS_text) as ITxtStrTextNode; // : DOM.findPreviousIn(txtStr, DOM.IS_text);
						selMgr.setSelAnchor(node, node.startBoundary ? 1 : 0);
					} else {
						console.log("fixupSelection : no txtStr Found (2)");
					}
				}
			}
		}
		if (what & 2) {
			const focusNode = selMgr.focusNode;
			const child = focusNode.childNodes[selMgr.focusOffset];
			if (range.startContainer === focusNode) {
				//focusNode est avant l'anchor => on cherche un text après de préférence
				let txtStr = findTxtStrNext(child || DOM.findNextUncle(focusNode, this));
				if (txtStr) {
					const node = DOM.findNext(txtStr, txtStr, DOM.IS_text) as ITxtStrTextNode; // : DOM.findPreviousIn(txtStr, DOM.IS_text);
					selMgr.setSelFocus(node, node.startBoundary ? 1 : 0);
				} else {
					txtStr = findTxtStrPrevious(child || focusNode.lastChild || focusNode);
					if (txtStr) {
						const node = DOM.findPreviousIn(txtStr, DOM.IS_text) as ITxtStrTextNode;
						selMgr.setSelFocus(node, node.endBoundary ? node.length - 1 : node.length);
					} else {
						console.log("fixupSelection : no txtStr Found (3)");
					}
				}
			} else {
				//focusNode est après l'anchor => on cherche un text avant de préférence
				let txtStr = child ? findTxtStrPrevious(child) : findTxtStrLastChild(focusNode) || findTxtStrPrevious(focusNode);
				if (txtStr) {
					const node = DOM.findPreviousIn(txtStr, DOM.IS_text) as ITxtStrTextNode;
					selMgr.setSelFocus(node, node.endBoundary ? node.length - 1 : node.length);
				} else {
					txtStr = findTxtStrNext(child || DOM.findNextUncle(focusNode, this));
					if (txtStr) {
						const node = DOM.findNext(txtStr, txtStr, DOM.IS_text) as ITxtStrTextNode; // : DOM.findPreviousIn(txtStr, DOM.IS_text);
						selMgr.setSelFocus(node, node.startBoundary ? 1 : 0);
					} else {
						console.log("fixupSelection : no txtStr Found (4)");
					}
				}
			}
		}
		return false; //return si updaté pas codé, plus utilisé
	}

	moveCaret(backward: boolean, alter: "extend" | "move" = "move", granularity: "word" | "character" = "character") {
		const selMgr = this.selMgr;
		const focusNode = selMgr.focusNode;
		if (focusNode instanceof Text) {
			findTxtStrParent(focusNode).moveCaretFrom(selMgr, backward, alter, granularity);
		} else if (IS_TxtElement(focusNode)) {
			//un objet est sélectionné dans l'éditeur
			//FIXME affecter un selection.anchorPoint en cas de "extend", mais impossible avec chrome si extBlock en début ou fin !
			focusNode.moveCaretOut(selMgr, backward, "move");
		} else {
			(findTxtStrFirstChild(this) || findTxtEltFirstChild(this)).setCaretIn(selMgr, true);
		}
	}

	/**
	 * Déplacement vertical du caret (ArrowUp, ArrowDown).
	 * @return true si le déplacement a été géré, false si on laisse l'algo par défaut gérer.
	 */
	moveCaretV(backward: boolean, alter: "extend" | "move" = "move"): boolean {
		const selMgr = this.selMgrAsIs;
		const focusNode = selMgr.focusNode;
		let paraSib: TxtParaLike | TxtObject = null;
		if (focusNode) {
			const p = findTxtParaLikeFrom(focusNode);
			if (p) {
				const selType = selMgr.type;
				if (selType === 'Caret' || selType === 'Range') {
					const rCaret = selMgr._sel.getRangeAt(0).getBoundingClientRect();
					//on compare au rect du content du p, pour éliminer le padding du P.
					const rgP = new Range();
					rgP.selectNodeContents(p);
					const pCaret = rgP.getBoundingClientRect();
					if (backward) {
						//Si on n'est pas sur la 1ère ligne, on laisse l'algo par défaut.
						if (rCaret.top > pCaret.top) return false;
					} else {
						//Si on n'est pas sur la dernière ligne, on laisse l'algo par défaut.
						if (rCaret.bottom < pCaret.bottom) return false;
					}
				}
				paraSib = p;
			} else {
				paraSib = DOM.findParentOrSelf(focusNode, this, (n: Node): n is TxtObject => n instanceof TxtObject);
				if (!paraSib && this.isMonoPara) {
					//On est en mono-para, on n'a pas trouvé "p", mais le TxtRoot fait l'objet de "p".
					return false; //Comportement natif inter-lignes.
				}
			}
		}
		if (paraSib) {
			let nextP: TxtParaLike | TxtObject;
			if (backward) {
				nextP = DOM.findPrevious(paraSib, this, (n: Node): n is TxtParaLike | TxtObject => n instanceof TxtParaLike || n instanceof TxtObject);
			} else {
				nextP = DOM.findNext(paraSib, this, (n: Node): n is TxtParaLike | TxtObject => n instanceof TxtParaLike || n instanceof TxtObject);
			}
			if (nextP) {
				if (paraSib instanceof TxtParaLike && nextP instanceof TxtParaLike) {
					//if (paraSib.parentNode === nextP.parentNode) return false; NON bug si marque d'erreur dans un span. //saut entre 2 para consécutif, on laisse l'algo par défaut.
					//TODO search caret position avec x similaire
					//TODO Attente impl chromium caretPositionFromPoint()  https://bugs.chromium.org/p/chromium/issues/detail?id=388976
				}
				nextP.setCaretIn(selMgr, !backward, alter);
			} else {
				paraSib.setCaretIn(selMgr, backward, alter);
			}
		} else {
			(findTxtStrFirstChild(this) || findTxtEltFirstChild(this)).setCaretIn(selMgr, backward);
		}
		return true;
	}
}

AgEltBoxInsertDrawerTxt(AgEltBoxSelection(AgEltBoxInputAnnotable(TxtRoot), {selMode: 'caret'}));

window.customElements.define("txt-root", TxtRoot);


class WedTxtRootCtx extends WedletActionCtxBase implements ITxtRootContext, ITxtTableContext {
	focusedElt: TxtRoot;
	txTable: TxtTable;
	logicTable: TXTTABLE.LogicTable;

	get wedlet(): IWedlet {return this.focusedElt.wedlet}

	get reg(): IReg<any> {return this.focusedElt.wedMgr.reg}

	get wedMgr(): WedMgr {return this.focusedElt.wedMgr}

	get txtRoot(): TxtRoot {return this.focusedElt}

	get accelKeyMgr(): AccelKeyMgr<ITxtRootContext> {return this.focusedElt.accelKeyMgr}

	onRefreshCycle(before: boolean): 'stop' | void {return this.focusedElt.onRefreshCycle(before)}
}

/**
 * Root ne contenant qu'un et un seul paragraphe, pouvant contenir du balisage inline.
 * Pas utilisé actuellement.
 * Usage
 * <wed:bind eltName="para" wedlet="Box" label="Para">
 *  <box-ctn skin="box/head-body" class="h">
 *   <txt-root-inline  adjust-virtuals="no">
 *    <wed:children defaultDisplay="#"/>
 *    <txt:descendants>...</txt:descendants>
 *    <txt:uiconfig>...</txt:uiconfig>
 *   </txt-root-inline>
 *  </box-ctn>
 * <wed:bind/>
 */
class TxtRootInline extends TxtRoot {

	get isMonoPara() {return true}

	constructor() {
		super();
		this.addEventListener('focusout', this.onFocusout);
	}

	onChildWedletsChange() {
		adjustVirtualsStr(this);
	}

	insertVirtualStr(before: Node): void {
		const strModel = this.strModel;
		const childrenElt = this.wedConfig.wedChildrenElt;
		const str = strModel.createWedlet(this.wedlet, childrenElt.wedDefaultDisplay) as TxtStr;
		str.configWedletElt(strModel.config, str);
		if (childrenElt.wedSlotName) str.setAttribute("slot", childrenElt.wedSlotName);
		(str as IElementWedlet).fromChildrenElt = childrenElt;
		this.insertBefore(str, before);
		str.bindAsVirtual();
	}

	onFocusin(ev: FocusEvent) {
		super.onFocusin(ev);
		DOMSH.findHost(this).setAttribute("selectin", "");
	}

	onFocusout(ev: FocusEvent) {
		DOMSH.findHost(this).removeAttribute("selectin");
	}
}

window.customElements.define("txt-root-inline", TxtRootInline);


/**
 * Bind "Str" pour binder directement un noeud texte txt-str, avec gestion espaces inséccables, OnTyping, etc.
 *
 * Config pour inclure des styles :
 * <wed:bind nodeType="text" wedlet="Str">
 *  <box-static skin="...">
 *    <txt-root-str/>
 *  <box-static>
 * </wed:bind>
 *
 * Config pour stylage externe :
 * <wed:bind nodeType="text" wedlet="Str">
 *  <txt-root-str/>
 * </wed:bind>
 *
 * Techniquement, le wedlet est le TxtStrAlone qui étend TxtStr,
 * et TxtStrAlone.element est un TxtRootStr qui étend TxtRoot.
 */
export class StrModel extends TxtStrModel {

	get isBoxFamily(): boolean {return true}

	protected _modes: string[]

	get modes(): string[] {return this._modes || WED.DEFAULT_MODES};

	set modes(val: string[]) {
		this._modes = val;
	}


	createWedlet(parent: IParentWedlet, displayContext?: IWedDisplayElt): TxtStrAlone | null {
		return new TxtStrAlone().initWedlet(this, parent, displayContext);
	}

	protected newWedlet(): TxtElement {throw "notUsed"}

}

WED.registerWedletModel("Str", StrModel);

/**
 * TxtStr utilisé seul via le IWedletModel StrModel.
 * @see StrModel pour utilisation.
 */
export class TxtStrAlone extends TxtStr implements IWedletSingleElt, IEditableWedlet {

	xaPart: /*string pour bindWithAttr*/ | number | null;

	protected _element: IElementWedlet;

	get element(): IElementWedlet {return this._element}

	getVirtualXaPart(): any /*number | string*/ {
		if (this.model.nodeType === ENodeType.attribute) return this.model.nodeName; //cas TxtStrAlone en attribut.
		return super.getVirtualXaPart();
	}

	bindWithNode(xaOffest: number, node: IJmlObj | string, children: IJmlSubSet): void | Promise<void> {
		this.refreshEditMode();
		return super.bindWithNode(xaOffest, node, children);
	}

	bindAsVirtual(): this {
		this.refreshEditMode();
		return super.bindAsVirtual();
	}

	bindWithAttr(nameAttr: string, value: string): void | Promise<void> {
		this.refreshEditMode();
		this.xaPart = nameAttr as any;
		this.element.refreshBindValue(value);
	}

	refreshEditMode() {
		this.txtRoot.contentEditable = WEDLET.isWritableWedlet(this.wedlet.wedParent) ? 'true' : 'false';
	}

	refreshBindValue(val: IJmlNode) {
		super.refreshBindValue(val);
	}

	/** On cree le container TxtRootStr intermédiaire et on l'insère. */
	insertElement(parent: Element, insertBefore?: Node, slotName?: string, caller?: IWedChildrenElt) {
		const tpl = this.model.config;
		const root = this._element = document.importNode(tpl.firstElementChild, false) as IElementWedlet;
		if (slotName) root.setAttribute("slot", slotName);
		root.configWedletElt(tpl.firstElementChild, this);
		if (caller) (root as IElementWedlet).fromChildrenElt = caller;
		(root as IBoxElement).subEltWedlets?.push(this);
		const strRoot = root instanceof TxtRootStr ? root : root.shadowRoot.querySelector('txt-root-str') as TxtRootStr;
		strRoot.appendChild(this);
		evalPlaceHolder(strRoot, this);
		//strRoot.configWedletElt(this.model.config, this); appelé dans root.
		parent.insertBefore(root, insertBefore);
	}

	onAddedSkAnnot(annot: ISkAnnot, xaTarget: IXAddr): void {
		if (WEDLET.diffLib?.isDiffAnnot(annot) && annot.diffSession === this.wedMgr.docHolder.getDiffSession() && LANG.in(annot.type, "diffValue", "diffMark")) {
			if (annot.type === "diffValue") {
				(document.createElement("wed-diff-value") as WedDiffValue).initDiffValue(annot as IDiffAnnotValue, this.element, this.wedMgr);
			} else {
				(document.createElement("wed-diff-mark") as WedDiffMark).initDiffAnnot(this.parentElement, annot, this).defaultInject();
			}
		} else {
			super.onAddedSkAnnot(annot, xaTarget);
		}
	}

	onRemovedSkAnnot(annot: ISkAnnot, xaTarget: IXAddr): void {
		if (WEDLET.diffLib?.isDiffAnnot(annot) && annot.diffSession === this.wedMgr.docHolder.getDiffSession() && LANG.in(annot.type, "diffValue", "diffMark")) {
			if (annot.type === "diffValue") {
				const parent = this.element as IElementWedlet & IWedAnnotPointer;
				if (parent.wedAnnotDiff?.skAnnot === annot) parent.wedAnnotDiff.removeDiffWidget();
			} else {
				const parent = this.parentElement as IElementWedlet & IWedAnnotPointer;
				if (parent.wedAnnotDiff?.skAnnot === annot) parent.wedAnnotDiff.removeDiffWidget();
			}
		} else {
			super.onRemovedSkAnnot(annot, xaTarget);
		}
	}

	async onClipboard(act: "copy" | "cut" | "paste", ev?: Event, options?: Dict<any>): Promise<boolean> {
		//copy/cut/paste de l'intégralité du texte ici, indépendamment de la sélection courante.
		this.getXmlText()
		switch (act) {
		case "copy":
			return this.onCopy(ev, options);
		case "cut":
			return this.onCut(ev, options);
		case "paste":
			return this.onPaste(ev, options);
		}
	}

	async onCopy(ev?: Event, options?: Dict<any>): Promise<boolean> {
		await CLIPBOARD.writeInClipboard(() => navigator.clipboard.write([new ClipboardItem({
			"text/plain": new Blob([this.getXmlText()], {type: "text/plain"})
		})]), this);
		return true;
	}

	async onCut(ev?: Event, options?: Dict<any>): Promise<boolean> {
		await CLIPBOARD.writeInClipboard(() => navigator.clipboard.write([new ClipboardItem({
			"text/plain": new Blob([this.getXmlText()], {type: "text/plain"})
		})]), this);
		const xa = this.wedAnchor;
		if (XA.isAttribute(xa)) this.wedMgr.docHolder.newBatch().setAttr(xa, null).doBatch();
		else this.wedMgr.docHolder.newBatch().deleteSequence(xa, 1).doBatch();
		return true;
	}

	async onPaste(ev?: Event, options?: Dict<any>): Promise<boolean> {
		//Appelé uniquement en remplacement complet de l'attr/textNode.
		let str = await CLIPBOARD.readText(this);
		if (str) {
			if (this.transformInsertData) str = this.transformInsertData(str);
			const xa = this.wedAnchor;
			if (this.isVirtual()) {
				WEDLET.insertDatasFromDisplay(this, null, str);
			} else if (XA.isAttribute(xa)) {
				this.wedMgr.docHolder.newBatch().setAttr(xa, str).doBatch();
			} else {
				this.wedMgr.docHolder.newBatch().setText(xa, str).doBatch();
			}
			return true;
		}
		return false;
	}
}

AgWedletBoxSelectionSingleElt(TxtStrAlone);
window.customElements.define("txt-str-alone", TxtStrAlone);

/**
 * Root utilisé par TxtStrAlone et noeud à déclarer dans le body du wedlet.
 * @see StrModel pour utilisation.
 */
export class TxtRootStr extends TxtRoot implements IBoxInputDiffMaker {

	get isMonoPara() {return true}

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		this.wedlet = wedlet as IParentWedlet & IWedletSingleElt;
		this.wedMgr = wedlet.wedMgr;
		this.selMgrAsIs = new (this.wedMgr.reg.getSvc<typeof TxtSelMgr>("wedTxtSelMgrClass") || TxtSelMgr)(this);
		this.contentEditable = WEDLET.isWritableWedlet(wedlet.wedParent) ? 'true' : 'false';
		this.wedConfig = tpl as Element & ITxtRootModel;
	}

	async doPaste(targetHint?: "string" | "text" | "markdown" | undefined, trsfFiles?: DataTransfer, clipboardItems?: ClipboardItem[]): Promise<void> {
		if (!trsfFiles && !clipboardItems) {
			clipboardItems = await WEDLET.readClipboard();
			if (clipboardItems == null || clipboardItems.length === 0) return;
		}
		if (clipboardItems[0].types.indexOf('text/plain') >= 0) {
			const txtStr = DOM.findFirstChild(this, IS_TxtStr);
			if (txtStr?.transformInsertData) {
				const oldD = await CLIPBOARD.text(clipboardItems[0], "text/plain");
				const newD = txtStr.transformInsertData(oldD);
				if (!newD) return;
				if (oldD !== newD) clipboardItems = [new ClipboardItem({"text/plain": newD})];
			}
		}
		return super.doPaste(targetHint || "text", trsfFiles, clipboardItems);
	}

	makeInputForDiff(annot: IDiffAnnotValue): HTMLElement {
		console.log(":::makeInputForDiff", annot.otherValue);
		return null;
	}
}

window.customElements.define("txt-root-str", TxtRootStr);

//*****************


REG.reg.registerSkin("txt-root/InlineMarker", 1, /*language=CSS*/ `
	inl-style::before,
	inl-phrase::before,
	inl-leaf::before,
	inl-link::before {
		content: '<';
		color: var(--edit-tagmark-color, rgba(194, 194, 194, .64));
	}

	*[in-sel~="start"]::before {
		background-color: var(--edit-seltext-bgcolor);
	}

	inl-style::after,
	inl-phrase::after,
	inl-leaf::after,
	inl-link::after {
		content: '>';
		color: var(--edit-tagmark-color, rgba(194, 194, 194, .64));
	}

	*[in-sel~="end"]::after {
		background-color: var(--edit-seltext-bgcolor);
	}

	txt-ul,
	txt-ol,
	txt-sl {
		border-inline-start: 2px solid var(--edit-tagmark-color, rgba(194, 194, 194, .64));
		padding-inline-start: 2px;
	}
`);

function split(str: string): string[] {return str ? str.trim().split(/ +/) : null}

/** **/
function evalPlaceHolder(eltFrom: TxtRoot, eltTarget: TxtElement) {
	if (eltFrom.hasAttribute("placeholder")) eltTarget.setAttribute("placeholder", eltFrom.getAttribute("placeholder"));
	else if (eltFrom.hasAttribute("placeholderup")) {
		const placeholderupAtt = eltFrom.getAttribute("placeholderup");
		const axePos = placeholderupAtt.indexOf(":");
		if (axePos != -1) {
			const axe = placeholderupAtt.substring(0, axePos);
			let wedlet: IWedlet;
			let minLevel;
			let maxLevel;
			const bounds = placeholderupAtt.substring(axePos + 1);
			if (bounds.indexOf(":") > -1) {
				minLevel = parseInt(bounds.substring(0, bounds.indexOf(":")), 10);
				maxLevel = parseInt(bounds.substring(bounds.indexOf(":") + 1), 10);
			} else {
				minLevel = 0;
				maxLevel = parseInt(bounds, 10);
			}
			switch (axe) {
			case "down" :
				wedlet = eltFrom.wedlet;
				for (let i = 0; wedlet && i < minLevel; i++) wedlet = wedlet.wedParent;
				let lastFindPlaceholder = "";
				for (let i = minLevel; wedlet && i < maxLevel; i++) {
					wedlet = wedlet.wedParent;
					if (wedlet && isWedletSingleElt(wedlet) && wedlet.element.getAttribute("placeholder"))
						lastFindPlaceholder = wedlet.element.getAttribute("placeholder");
				}
				if (lastFindPlaceholder) eltTarget.setAttribute("placeholder", lastFindPlaceholder);
				break;
			case "up" :
				wedlet = eltFrom.wedlet;
				for (let i = 0; wedlet && i < minLevel; i++) wedlet = wedlet.wedParent;
				for (let i = minLevel; wedlet && i < maxLevel; i++) {
					if (wedlet && isWedletSingleElt(wedlet) && wedlet.element.getAttribute("placeholder")) {
						eltTarget.setAttribute("placeholder", wedlet.element.getAttribute("placeholder"));
						return;
					}
					wedlet = wedlet.wedParent;
				}
				break;
			default :
				throw "axe unknown in : " + placeholderupAtt;
			}
		} else {
			const up = parseInt(placeholderupAtt, 10);
			let wedlet: IWedlet = eltFrom.wedlet;
			for (let i = 0; wedlet && i < up; i++) wedlet = wedlet.wedParent;
			if (wedlet && isWedletSingleElt(wedlet) && wedlet.element.getAttribute("placeholder")) eltTarget.setAttribute("placeholder", wedlet.element.getAttribute("placeholder"));
		}
	}
}


export class Box2TxtModel extends BoxModel {

	buildModelForFragment(insertCtx: IWedlet): IWedletModel {
		return this;
	}
}

WED.registerWedletModel("Box2Txt", Box2TxtModel);


export const txtTagsDefined = Promise.resolve();
